import React, { Component } from "react";

export default class Input extends Component {
  constructor(props) {
    super(props);
    this.state = { value: "", selectedValue: "", height: null };

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeTextArea = this.handleChangeTextArea.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleChangeTextArea(event) {
    let str = event.target.value.replace(/(?:\r\n|\r|\n)/g, "$");
    str = str.split("$").length;
    this.setState({ value: event.target.value, height: str });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  handleChangeDate(date) {
    this.setState({ selectedValue: date });
    this.setState({ startDate: date });
  }

  setType = () => {
    const { children, type, name, className, pattern, required } = this.props;
    const { value, height } = this.state;
    switch (type) {
      case "textarea":
        let setHeight = height ? height * 30 : 40;
        return (
          <textarea
            style={{ height: setHeight <= 35 ? 40 : setHeight }}
            name={name}
            id={name}
            maxLength="1000"
            onChange={this.handleChangeTextArea}
          ></textarea>
        );


      default:
        return (
          <input
            type={type ? type : "text"}
            name={name}
            id={name}
            maxLength="100"
            required={required}
            pattern={pattern}
            onChange={this.handleChange}
          />
        );
    }
  };

  render() {
    const { children, type, name, className, pattern, required } = this.props;
    const { value, selectedValue } = this.state;

    if (type === "submit") {
      return <input type="submit" value={children} className={className} />;
    } else {
      return (
        <label
          htmlFor={name}
          className={`${className} ${
            value !== "" || selectedValue !== "" ? "filled" : "empty"
          } ${required ? "is-required" : ""}`}
        > 
        <span>{children}</span>
          {this.setType()}
         
          <p className="error">Palun täida kõik kohustuslikud väljad!</p>
        </label>
      );
    }
  }
}
